<template>
  <div class="box">
    <div class="content">
      <div id="top_data_show" v-loading="isShowDataLoading">
        <div class="data_item" v-for="item in showTopDataList" :key="item.key">
          <img :src="item.imgSrc" style="width: 42px;height: 42px;"/>
          <div style="margin-left: 10px;">
            <div style="font-size: 14px;color: rgba(0,0,0,0.65);">{{ item.name }}</div>
            <div style="font-size: 30px;margin-top: 4px;">{{ item.data }}</div>
          </div>
        </div>
      </div>
      <div>
        <el-form
            ref="ruleFormRef"
            :model="ruleForm"
            :label-width="formLabelWidth"
            class="demo-ruleForm"
            label-position="right"
            status-icon
        >
          <div style="display: flex;flex-wrap: wrap;justify-content: flex-start;width: 88%">
            <el-form-item :label="`${$t('sending.customer.search.no')}:`" prop="taskCode">
              <el-input size="small" style="width: 200px !important;" v-model="ruleForm.taskCode"
                        :placeholder="$t('common.please.input')"/>
            </el-form-item>
            <el-form-item :label="`${$t('common.step.search.2')}:`" prop="title">
              <el-input size="small" style="width: 200px !important;" v-model="ruleForm.title"
                        :placeholder="$t('common.please.input')"/>
            </el-form-item>
            <el-form-item :label="`${$t('common.step.txt.1')}:`">
              <el-select size="small" v-model="ruleForm.types" :placeholder="$t('common.please.select')">
                <el-option v-for="item in options" :key="item.label" :label="item.label" :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('sending.customer.search.massMailType')}:`"
                          prop="massMailType">
              <el-select size="small" v-model="ruleForm.massMailType" :placeholder="$t('common.please.select')">
                <el-option :label="$t('sending.customer.option.massMailType.system')" :value="1"/>
                <el-option :label="$t('sending.customer.option.massMailType.smart')" :value="2"/>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('sending.customer.search.createName')}:`" prop="createBy"
            >
              <el-select size="small" v-model="ruleForm.createBy" :placeholder="$t('common.please.select')"
                         :default-first-option="true">
                <el-option
                    v-for="item in tableDataSelect"
                    :label="item.userName"
                    :value="item.userId"
                    :key="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('sending.customer.search.taskStatus')}:`" prop="taskStatus">
              <el-select size="small" v-model="ruleForm.taskStatus" :placeholder="$t('common.please.select')">
                <el-option :label="$t('sending.search.status1')" style="color: #9c9ea2" :value="1"/>
                <el-option :label="$t('sending.search.status2')" style="color: #5a9cf8" :value="2"/>
                <el-option :label="$t('sending.search.status3')" style="color: #dca550" :value="3"/>
                <el-option :label="$t('sending.search.status4')" style="color: #7ec050" :value="4"/>
                <el-option :label="$t('sending.search.status5')" style="color: #e47470" :value="5"/>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('common.start.time')}:`" prop="taskStartTime"
                          :style="{width: formItemWidth}">
              <el-date-picker
                  size="small"
                  style="width: 100%;"
                  v-model="ruleForm.taskStartTime"
                  type="daterange"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  date-format="YYYY/MM/DD"
                  :start-placeholder="$t('sending.customer.search.startTime')"
                  :end-placeholder="$t('sending.customer.search.endTime')"
              />
            </el-form-item>
            <el-form-item :label="`${$t('common.end.time')}:`" prop="taskEndTime"
                          :style="{width: formItemWidth}">
              <el-date-picker
                  size="small"
                  style="width: 100%;"
                  v-model="ruleForm.taskEndTime"
                  type="daterange"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  date-format="YYYY/MM/DD"
                  :start-placeholder="$t('sending.customer.search.startTime')"
                  :end-placeholder="$t('sending.customer.search.endTime')"
              />
            </el-form-item>
          </div>
          <div>
            <el-form-item style="margin-right:2px;">
              <div style="display: flex">
                <el-button style="margin-right: 10px" size="small" type="primary" @click="onSubmit(ruleFormRef)">
                  {{ $t('common.query') }}
                </el-button>
                <el-button style="margin-right: 2px;" size="small" @click="resetForms(ruleFormRef)">
                  {{ $t('common.reset') }}
                </el-button>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div style="display: flex;flex-direction: column">
        <!--        top-->
        <div class="table_top">
          <div class="h2_titles">{{ $t('sending.table.title') }}</div>
          <!--          <div style="background: #dca550;color: white;border-radius: 4px;line-height: 40px;padding: 0px 10px">为了保证用户体验和使用效率，系统数据库和配置正在全面升级中，群发模块预计24小时内完成全部升级，感谢支持</div>-->
          <div>
            <el-button
                type="danger"
                :icon="Delete"
                @click="handleClickDelete"
                style="margin-right: 12px"
                size="small"
            >{{ $t('common.delete') }}
            </el-button
            >
            <el-button size="small" type="primary" @click="createNewTask">
              <img src="../../assets/sendgroup/send.png"
                   width="18"
                   style="margin-right: 8px"/>
              {{
                $t('sending.create.grouptask')
              }}
            </el-button>
          </div>
        </div>
        <!--      table-->
        <div>
          <el-table
              ref="multipleTableRef"
              :data="tableData"
              style="width: 100%;margin-top: 16px"
              :header-cell-style="headerClassName"
              @selection-change="handleSelectionChange"
              @select-all="handleClickSelectAll"
              v-loading="loading"
              :cell-style="rowClassName"
          >
            <el-table-column type="selection" width="30" :selectable="checkSelectable"/>
            <el-table-column
                :label="$t('sending.table.col.taskId')"
                prop="taskCode"
                :width="getColumnWidth('taskCode', $t('sending.table.col.taskId'), { extra: 10 })"
            >
              <template #default="{row}">
                <router-link
                    :to="'/email/customer/senddetail/' + row.id+`/${row.massMailType}/${row.taskCode}/${row.userId}`"
                    style="color: #409eff"
                >
                  <el-button link type="primary">{{ row.taskCode }}</el-button>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column
                :label="$t('common.step.search.2')"
                prop="taskName"
                :min-width="110"
                :width="getColumnWidth('taskName', $t('common.step.search.2'))"
            >
              <template #default="{row}">
                <!--                {{ row.taskName}}-->
                <el-tooltip
                    v-if="getTextLength(row.taskName) > sizeMaxNumber"
                    placement="top"
                    :show-after="1200"
                    popper-class="remark-tooltip"
                >
                  <template #content>
                    <div class="popover-content">{{ row.taskName }}</div>
                  </template>

                  <!-- 👇 这个是触发 tooltip 的可见元素 -->
                  <span class="sending">{{
                      getTextLength(row.taskName) > sizeMaxNumber ? formatText(row.taskName, sizeMaxNumber) : row.taskName
                    }}</span>
                </el-tooltip>
                <!-- 没有内容时 -->
                <div v-else>
                  {{ row.taskName }}
                </div>
              </template>
            </el-table-column>
            <!--            营销类型-->
            <el-table-column :label="$t('common.step.txt.1')" prop="massMarketType"
                             :width="lang==='en'?200:80">
              <template #default="{row}">
                <template v-if="row.massMarketType===1">{{ $t('common.step.txt.select.1') }}</template>
                <template v-if="row.massMarketType===2">{{ $t('common.step.txt.select.2') }}</template>
                <template v-if="row.massMarketType===3">{{ $t('common.step.txt.select.3') }}</template>
                <template v-if="row.massMarketType===4">{{ $t('common.step.txt.select.4') }}</template>
                <template v-if="row.massMarketType===5">{{ $t('common.step.txt.select.5') }}</template>
                <template v-if="row.massMarketType===6">{{ $t('common.step.txt.select.6') }}</template>
                <template v-if="row.massMarketType===7">{{ $t('common.step.txt.select.7') }}</template>
                <template v-if="row.massMarketType===8">{{ $t('common.step.txt.select.8') }}</template>
              </template>
            </el-table-column>
            <!--            宽度自适应？-->
            <el-table-column :label="$t('sending.table.col.massMailType')" prop="massMailType"
                             :width="lang==='en'?180:80">
              <template #default="{row}">
                <template v-if="row.massMailType===1">{{ $t('sending.table.col.massMailType.way1') }}</template>
                <template v-if="row.massMailType===2">{{ $t('sending.table.col.massMailType.way2') }}</template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('sending.table.col.startTime')" prop="startTime"
                             :width="getColumnWidth('startTime', $t('sending.table.col.startTime'))">
            </el-table-column>
            <el-table-column :label="$t('common.sending.over.time')" prop="endTime"
                             :width="getColumnWidth('endTime', $t('common.sending.over.time'))">
            </el-table-column>
            <el-table-column :label="$t('sending.table.col.createName')" prop="createName"
                             :width="getColumnWidth('createName', $t('sending.table.col.createName'), { minWidth: 100 })">
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                :label="$t('send.all.remark')"
                prop="remark"
                :width="80"
            >
              <template #default="scope">
                <div class="flex items-center">
                  <el-tooltip
                      class="box-item"
                      :disabled="!scope.row.remark"
                      :content="scope.row.remark"
                      placement="right"
                      :show-after="1200"
                      popper-class="remark-tooltip"
                  >
                    <el-icon
                        @click.stop="handleClickRemark(scope.row)"
                        :color="scope.row.remark ? '#40a9ff' : '#dddddd'"
                    >
                      <Memo/>
                    </el-icon>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('sending.customer.search.taskStatus')" prop="taskStatus"
                             :width="getColumnWidth('taskStatus', $t('sending.customer.search.taskStatus'), { extra: 20, minWidth: lang === 'en' ? 140 : 0 })">
              <template #default="{row}">
                <el-button size="small" link type="info" v-if="row.taskStatus===1" class="btn_reset">
                  {{ $t('sending.search.status1') }}
                </el-button>
                <el-button size="small" link type="primary" v-if="row.taskStatus===2" class="btn_reset">
                  {{ $t('sending.search.status2') }}
                </el-button>
                <el-button size="small" link type="warning" v-if="row.taskStatus===3" class="btn_reset">
                  {{ $t('sending.search.status3') }}
                </el-button>
                <el-button size="small" link type="success" v-if="row.taskStatus===4" class="btn_reset">
                  {{ $t('sending.search.status4') }}
                </el-button>
                <el-button size="small" link type="danger" v-if="row.taskStatus===5" class="btn_reset">
                  {{ $t('sending.search.status5') }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column :label="$t('sending.table.col.massMailCount.num')" prop="massMailCount"
                             :width="getColumnWidth('massMailCount', $t('sending.table.col.massMailCount.num'), { extra: 20 })">
            </el-table-column>
            <el-table-column :label="$t('sending.table.col.successCount')" prop="successCount"
                             :width="getColumnWidth('successCount', $t('sending.table.col.successCount'), { extra: 20 })">
              <template #default="{row}">
                <el-button size="small" type="success" link class="btn_reset">{{ row.successCount }}</el-button>
              </template>
            </el-table-column>
            <el-table-column :label="$t('sending.table.col.openCount')" prop="openCount"
                             :width="getColumnWidth('openCount', $t('sending.table.col.openCount'), { extra: 20 })">
              <template #default="{row}">
                <el-button size="small" link type="info" class="btn_reset">{{ row.openCount }}</el-button>
              </template>
            </el-table-column>
            <el-table-column :label="$t('sending.table.col.replyCount')" prop="replyCount"
                             :width="getColumnWidth('replyCount', $t('sending.table.col.replyCount'), { extra: 20 })">
            </el-table-column>
            <el-table-column :label="$t('sending.table.col.failCount')" prop="failCount"
                             :width="getColumnWidth('failCount', $t('sending.table.col.failCount'), { extra: 20 })">
              <template #default="{row}">
                <el-button size="small" type="danger" link class="btn_reset">{{ row.failCount }}</el-button>
              </template>
            </el-table-column>
            <!--            -->
            <el-table-column :label="$t('common.operate')" prop="taskStatus"
                             style="max-width: 180px;"
                             align="center"
                             :width="computedTargetWidth"
            >
              <template #default="{row}">
                <div ref="setting" class="optionDiv">
                  <!--任务未开始的时候可以进行编辑-->
                  <!--                  v-if="row?.taskStatus===1"-->
                  <el-button v-if="row?.taskStatus===1" size="small" type="primary" link @click="handleClickEdit(row)">
                    {{ $t('common.edit') }}
                  </el-button>
                  <el-button size="small" type="primary" link @click="toTargetDetail(row)">{{
                      $t('common.check')
                    }}
                  </el-button>
                  <el-button size="small" type="primary" link @click="toResendGroupMail(row)">{{
                      $t('common.resend')
                    }}
                  </el-button>
                  <ConfirmDeletePopover
                      :visible="row.popoverVisibleReject"
                      :width="164"
                      :message="$t('sending.table.list.row.delete')"
                      :ref="`popover-${$index}`"
                      @update:visible="
                    (value) => (row.popoverVisibleReject = value)
                  "
                      @confirm:delete="handleClickDeleteRow(row)"
                  >
                    <template #settings>
                      <el-button
                          v-if="row.taskStatus!==2"
                          link
                          type="danger"
                          @click.native.stop="row.popoverVisibleReject = true"
                      >{{ $t('common.delete') }}
                      </el-button>
                    </template>
                  </ConfirmDeletePopover>
                  <el-button size="small" type="warning" v-if="row.taskStatus===3" link
                             @click="handleChangeStatus(row,'1')">
                    {{ $t('common.continue') }}
                  </el-button>
                  <el-button size="small" type="danger" v-if="row.taskStatus===2" link
                             @click="handleChangeStatus(row,'2')">{{ $t('common.pause') }}
                  </el-button>
                  <el-button size="small" type="danger" v-if="row.taskStatus!==4 && row.taskStatus!==5" link
                             @click="handleChangeStatus(row,'3')">{{ $t('common.cancel') }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <template #empty>
              <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
            </template>
          </el-table>
          <div class="pages" style="margin-top: 10px">
            <Pagination v-model:modelValue="pageNo"
                        v-model:pageSizeValue="pageSize"
                        :total="totals"
                        v-if="totals"
                        ref="PageZQ"
                        :selected="selectedCount"
                        @change="handleCurrentChange"
                        @checkAllItemPage="checkAllItemPage"
                        @unCheckAllItemPage="unCheckAllItemPage"
                        @getSelect="getSelectValue"
                        :multipleSelection="multipleSelection"
                        :is-show-select="true"
            ></Pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CreateTaskDia v-model="visibleDialog" v-if="visibleDialog" @close="close" :isHeadLine="false"
                 :activeItem="activeItem"></CreateTaskDia>
  <DeleteGroupTask v-if="dialogVisiblePopover" v-model="dialogVisiblePopover" @close="closeDialog"
                   :multipleSelection="multipleSelection" :getGroupMailList="getGroupMailList"></DeleteGroupTask>
  <!--   添加备注   -->
  <Remark v-if="visitableRemark" v-model="visitableRemark" @close="closeRemark" :isHeadLine="false"
          :currentItem="currentItem" @getList="getGroupMailList" :task="true"></Remark>
</template>

<script setup>
import {computed, nextTick, onBeforeUnmount, onMounted, ref, watch} from "vue";
import {useTransition} from '@vueuse/core'
import CreateTaskDia from "@/views/SendGroup/compontents/CreateTaskDia.vue";
import {useStore} from "vuex";
import {throttle, debouncePlus} from "@/utils/mylodash"
import {useRouter} from "vue-router";
import {emptyUrl} from "@/utils/statusParams";
import {i18n} from "@/lang";
import {flexWidth} from '@/utils/tableWidth'
import {Delete} from "@element-plus/icons-vue";
import DeleteGroupTask from "@/components/DiaPops/DeleteGroupTask.vue";
import {ElMessage, ElTable} from "element-plus";
import {auto} from "@popperjs/core";
import Remark from "@/components/Remark/index.vue";
import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";
import {batchDeleteMassTask} from "@/api/groupSend";
import img1 from "@/assets/yingxiao/img1@2x.png"
import img2 from "@/assets/yingxiao/img2@2x.png"
import img3 from "@/assets/yingxiao/img3@2x.png"
import img4 from "@/assets/yingxiao/img4@2x.png"
import img5 from "@/assets/yingxiao/img5@2x.png"
import {getGroupStaticData} from "@/api/customer";
import {Storage} from "@/utils/storage";
import dayjs from "dayjs";
import {formatText, getTextLength} from "@/utils/util";
import sessionStore from "@/utils/sessionStore";
import Pagination from "@/components/Pagination/index.vue";

const TIME_DELAY = 300;
const ruleForm = ref({
  taskCode: "",
  massMailType: "",
  createBy: "",
  targetTime: [],
  // taskTime: [],
  taskStartTime: "",
  taskEndTime: "",
  taskStatus: "",
  types: ""
})
const store = useStore()
const router = useRouter();

const tableData = ref([])
const multipleTableRef = ref(null)

// 跨页选择相关状态
const globalSelectedRows = ref({}) // 存储每页的选中项 { pageNo: [rows] }
const isSelectAll = ref(false) // 是否全选
const shiftSelecting = ref(false) // 是否正在进行 Shift 选择
const selectedCount = ref(0) // 选中的条数
const PageZQ = ref() // 分页组件引用


const sizeMaxNumber = ref(13)
const isEnterpriseMainUser = computed(() => store.getters["user/isEnterpriseMainUser"])
const isAdmin = computed(() => store.getters["user/isAdmin"])
// 任务发起人
const tableDataSelect = computed(() => {
  if (isSuperAdmin.value || isAdmin.value) {
    return [...store.state.groups.AllTableData, {
      userName: i18n.global.t('common.all'),
      userId: 'all',
    }]
  } else {
    return store.state.groups.AllTableData
  }
});


const visibleDialog = ref(false);
const close = () => {
  visibleDialog.value = false
}
/**
 * 新建团队任务
 */
const createNewTask = () => {
  // visibleDialog.value = true;
  //   跳转到步骤 task
  // router.push(`/marketing?massOrigin=${1}`)
  sessionStore.set("marketing_time", dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"))
  const routeUrl = router.resolve({
    path: '/marketing',
    query: {massOrigin: 1, step: 0}
  })
  window.open(routeUrl.href, '_blank')
}

/**
 * 失败数量
 * @type {Ref<UnwrapRef<number>>}
 */
const sendError = ref(0)
const sendErrorValue = useTransition(sendError, {
  duration: 1000,
})
sendError.value = 172

/**
 * 成功数量
 */
const sendSuccess = ref(0)
const sendSuccessValue = useTransition(sendSuccess, {
  duration: 1000,
})
sendSuccess.value = 300


/**
 * 打开数量
 */
const openEmail = ref(0)
const openEmailValue = useTransition(openEmail, {
  duration: 1000,
})
openEmail.value = 300


/**
 * 回复数量
 */

const reEmail = ref(0)
const reEmailValue = useTransition(reEmail, {
  duration: 1000,
});
reEmail.value = 100


//表单查询相关
const ruleFormRef = ref(null);
const startTime = ref(null);
const endTime = ref(null)

const taskStartTime = ref(null);
const taskEndTime = ref(null);

const resetForms = debouncePlus(async () => {
  ruleFormRef.value.resetFields();
  ruleForm.value.targetTime = []
  ruleForm.value.taskStartTime = null
  ruleForm.value.taskEndTime = null
  ruleForm.value.createBy = tableDataSelect.value[0].userId;
  startTime.value = null;
  endTime.value = null;
  searchForm.value = {}
  pageNo.value = 1;
  await resetInit()
  getGroupMailList()
  getGroupStatic()
}, TIME_DELAY)
const searchForm = ref({})
const onSubmit = debouncePlus(async () => {
  const {targetTime, taskStartTime, taskEndTime, ...data} = ruleForm.value
  searchForm.value = {
    ...data,
    taskStartTime: taskStartTime && taskStartTime[0] ? `${taskStartTime[0]} 00:00:00` : null,
    taskEndTime: taskStartTime && taskStartTime[1] ? `${taskStartTime[1]} 23:59:59` : null,
    finishStartTime: taskEndTime && taskEndTime[0] ? `${taskEndTime[0]} 00:00:00` : null,
    finishEndTime: taskEndTime && taskEndTime[1] ? `${taskEndTime[1]} 23:59:59` : null
  }
  pageNo.value = 1;
  await resetInit()
  getGroupMailList()
  getGroupStatic()
}, TIME_DELAY)

// 暂停继续发送
const beginFlag = ref(false)
const handleChangeStatus = async (row, flag) => {
  const {id, taskStatus} = row
  const payload = {
    massTaskId: id,
    teamId: teamId.value
  }
  if (flag === "1") {
    //   继续
    payload.taskStatus = 2
  } else if (flag === "2") {
    //   暂停
    payload.taskStatus = 3
  } else if (flag === "3") {
    //   取消
    payload.taskStatus = 5
  }
  console.log(payload, 'payload')
  await store.dispatch("groupSend/updateMailMassStatusApis", payload)
  await getGroupMailList()
}


// 重发群发邮件
// active
const activeItem = ref(null)
const toResendGroupMail = async (row) => {
  console.log('重发', row);
  sessionStore.set("marketing_time", dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"))
  const {id} = row;
  activeItem.value = id;
  // const query = {
  //   type: row.massMailType,
  //   massTaskId: row.id,
  //   typeFlag: "reSent",
  //   mailType: "3"
  // };
  //
  // // 构造 query 字符串
  // const queryString = new URLSearchParams(query).toString();
  //
  // // 构造完整 URL（假设使用 history 模式）
  // const url = `${location.origin}/email/send_all?${queryString}`;
  // // 在新标签页打开
  // window.open(url, '_blank');
  const routeUrl = router.resolve({
    path: '/marketing',
    query: {massOrigin: 4, taskId: id, step: 0}
  })
  window.open(routeUrl.href, '_blank')
};


// 查看email详情
const toTargetDetail = (row) => {
  console.log(row, 'row')
  const {id, massMailType, taskCode, userId} = row
  router.push(`/email/customer/senddetail/${id}/${massMailType}/${taskCode}/${userId}`)
}

const handleClickEdit = (row) => {
  console.log(row, 'row')
  const routeUrl = router.resolve({
    path: '/marketing',
    query: {
      massOrigin: 2,
      step: 0,
      taskId: row.id,
    }
  })
  window.open(routeUrl.href, '_blank')
}


// 获取文件列表
const pageNo = ref(1);
const pageSize = ref(10);
const totals = ref(0);
const loading = ref(false)

const teamId = computed(() => store.state.email.teamID);
const userInfo = computed(() => store.state.user.userInfo);
const getGroupMailList = async () => {
  let params = {
    pageNo: pageNo.value,
    pageSize: pageSize.value,
    teamId: teamId.value,
    createBy: tableDataSelect.value[0].userId,
  }
  if (searchForm.value) {
    params = {...params, ...searchForm.value}
  }

  if (params.createBy === 'all') {
    params.createBy = '';
  }
  console.log(params, 'params')
  loading.value = true
  const res = await store.dispatch('groupSend/queryPageListApis', params)
  loading.value = false;
  const {records, total, current, size} = res;
  tableData.value = records;
  totals.value = total;
  pageNo.value = current;
}

// 判断是否是超级管理员如果是的话 就展示
const isSuperAdmin = computed(() => store.getters["user/isSuperAdmin"])
const isFirst = ref(false)
onMounted(async () => {
  // Shift监听/取消监听
  document.addEventListener('keydown', handleKeyDown);
  document.addEventListener('keyup', handleKeyUp);

  await store.dispatch("groups/getAllUserList", {teamId: teamId.value});
  ruleForm.value.createBy = tableDataSelect.value[0].userId;
  getGroupMailList()
  if (!isFirst.value) {
    getGroupStatic()
  }
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
  document.removeEventListener('keyup', handleKeyUp);
});

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 5 || columnIndex === 6 || columnIndex === 15) {
    return {
      'text-align': 'left',
      background: '#f9f9f9',
      color: 'black',
      padding: '8px 0px',
      'white-space': 'nowrap',
      'word-break': 'keep-all'
    }
  } else {
    return {
      'text-align': 'center',
      background: '#f9f9f9',
      color: 'black',
      padding: '8px 0px',
      'white-space': 'nowrap',
      'word-break': 'keep-all'
    }
  }
}

const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 5 || columnIndex === 6 || columnIndex === 15) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}
// 语言
const lang = computed(() => store.state.system.langLocal)
const formLabelWidth = computed(() => lang.value === 'en' ? '135px' : 'auto')
const getTextWidth = (text) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  if (!context) {
    return 0;
  }

  context.font = "500 13px Microsoft YaHei";
  return Math.ceil(context.measureText(text || "").width);
}

const getColumnWidth = (prop, title, options = {}) => {
  const {extra = 0, minWidth = 0} = options;
  const baseWidth = tableData.value.length ? (flexWidth(prop, tableData.value, title) || 0) : 0;
  const headerPadding = lang.value === 'en' ? 40 : 24;
  const headerWidth = getTextWidth(title) + headerPadding;

  return Math.max(baseWidth + extra, headerWidth + extra, minWidth);
}


const formItemWidth = computed(() =>
  lang.value === 'en' ? '335px' : '278px'
)

const computedTargetWidth = computed(() => {
  console.log('tableData.value', tableData.value)
//   是否存在 进行中
  const target1 = tableData.value.some(item => item.taskStatus === 1) ? 3 : 2
  const target2 = tableData.value.some(item => item.taskStatus === 2 || item.taskStatus === 3) ? 4 : 2
  const target3 = tableData.value.some(item => item.taskStatus === 4 || item.taskStatus === 5) ? 2 : 2

  const res = [target1, target2, target3]
  return lang.value !== 'zh-CN' ? Math.max(...res) * 85 : Math.max(...res) * 65;
})

const dialogVisiblePopover = ref(false);
const multipleSelection = ref([])

// 控制行是否可选（全选时禁用单行选择）
const checkSelectable = (row) => {
  return !isSelectAll.value
}

const handleClickDelete = throttle((row) => {
  if (multipleSelection.value.length === 0 && !isSelectAll.value) {
    ElMessage.warning(i18n.global.t('index.sending.multiple.select'));
    return;
  }
  dialogVisiblePopover.value = true
}, 2000)

// 单行删除
const handleClickDeleteRow = async (row) => {
  if (row) {
    multipleSelection.value = [row]
  }
  const payload = {
    taskIdList: multipleSelection.value.map(item => item.id),
    teamId: teamId.value,
  }
  await batchDeleteMassTask(payload).then(res => {
    ElMessage.success(res.message)
    resetInit()
    getGroupMailList()
  }).catch(e => {
  })
}


const handleSelectionChange = async (val) => {
  if (shiftSelecting.value) return
  console.log(val, 'handleSelectionChange - val')

  // 统一更新跨页选择状态：先更新当前页在 globalSelectedRows 中的记录
  const currentPage = pageNo.value
  globalSelectedRows.value = {...globalSelectedRows.value}
  globalSelectedRows.value[currentPage] = val

  // 计算跨页合并后的所有选中项，使用 id 去重
  const allSelectedMap = new Map()
  Object.values(globalSelectedRows.value).flat().forEach(item => {
    if (item && item.id) {
      allSelectedMap.set(item.id, item)
    }
  })
  const allSelected = Array.from(allSelectedMap.values())

  console.log('handleSelectionChange - currentPage:', currentPage)
  console.log('handleSelectionChange - globalSelectedRows:', globalSelectedRows.value)
  console.log('handleSelectionChange - allSelected:', allSelected)
  console.log('handleSelectionChange - allSelected count:', allSelected.length)

  // 更新选中项
  multipleSelection.value = allSelected
  selectedCount.value = allSelected.length

  endIndex = val.length > 1 ? tableData.value.findIndex(item => item.id === val[val.length - 1].id) : -1;
  const startIndex = val.length > 1 ? tableData.value.findIndex(item => item.id === val[val.length - 2].id) : -1;
  console.log(endIndex, startIndex);
  if (isShiftPressed.value && val.length > 1 && endIndex !== startIndex) {
    shiftSelecting.value = true
    const start = startIndex < endIndex ? startIndex : endIndex;
    const end = endIndex < startIndex ? startIndex : endIndex;
    for (let i = start; i <= end; i++) {
      const row = tableData.value[i];
      if (start === i || i === end) {
        continue;
      }
      console.log(row, '更新');
      if (row) {
        multipleTableRef.value.toggleRowSelection(row, true); // 调用表格组件的方法来更新选中状态
      }
    }
    nextTick(async () => {
      const selected = multipleTableRef.value.getSelectionRows()
      // Shift 选择完成后，重新更新当前页记录和合并状态
      const updatedGlobal = {...globalSelectedRows.value}
      updatedGlobal[currentPage] = selected
      // 使用 Map 去重
      const mergedMap = new Map()
      Object.values(updatedGlobal).flat().forEach(item => {
        if (item && item.id) {
          mergedMap.set(item.id, item)
        }
      })
      const merged = Array.from(mergedMap.values())
      globalSelectedRows.value = updatedGlobal
      multipleSelection.value = merged
      selectedCount.value = merged.length
      console.log('Shift selection completed - selected:', selected)
      console.log('Shift selection completed - merged:', merged)
      shiftSelecting.value = false
    });
  }
}

const handleClickSelectAll = async (val) => {
  console.log(val, '当前页勾选的值');
  // 获取当前页的页码
  const currentPage = pageNo.value;

  // 获取全局勾选记录
  globalSelectedRows.value = {...globalSelectedRows.value};

  // 更新当前页的勾选数据到全局记录
  globalSelectedRows.value[currentPage] = val;

  // 计算跨页合并后的所有选中项，使用 Map 去重
  const allSelectedMap = new Map()
  Object.values(globalSelectedRows.value).flat().forEach(item => {
    if (item && item.id) {
      allSelectedMap.set(item.id, item)
    }
  })
  const allSelectedRows = Array.from(allSelectedMap.values())

  // 更新选中项
  multipleSelection.value = allSelectedRows
  selectedCount.value = allSelectedRows.length
}
const closeDialog = () => {
  dialogVisiblePopover.value = false;
}

// 分页相关方法
const getSelectValue = async (val) => {
  if (val !== undefined) {
    isSelectAll.value = val
  }
  await nextTick()
  tableData.value.forEach((item) => {
    multipleTableRef.value.toggleRowSelection(item, isSelectAll.value)
  })
}

const checkAllItemPage = () => {
  console.log('checkAllItemPage')
  isSelectAll.value = true
}

const unCheckAllItemPage = () => {
  console.log('unCheckAllItemPage')
  isSelectAll.value = false
}

const handleCurrentChange = async (page) => {
  const {pageNo: newPageNo, pageSize: newPageSize} = page
  pageNo.value = newPageNo
  pageSize.value = newPageSize
  //  重新获取数据
  await getGroupMailList()
  // 全选
  if (isSelectAll.value) {
    await getSelectValue()
  } else {
    // 恢复当前页的选中状态
    await resetSelection()
  }
}

// 重置选择状态
const resetInit = async () => {
  isSelectAll.value = false
  try {
    await PageZQ.value?.setIsSelectAll(false)
    // 清空选项
    globalSelectedRows.value = {}
    multipleSelection.value = []
    selectedCount.value = 0
  } catch (e) {
    console.error(e)
  }
}

// 恢复当前页的选中状态
const resetSelection = async () => {
  await nextTick(() => {
    const currentPage = pageNo.value
    const currentPageSelected = globalSelectedRows.value[currentPage] || []
    console.log('resetSelection - currentPage:', currentPage, 'selected:', currentPageSelected)
    
    if (multipleTableRef.value && currentPageSelected.length > 0) {
      tableData.value.forEach((item) => {
        const isSelected = currentPageSelected.some((selected) => selected.id === item.id);
        multipleTableRef.value.toggleRowSelection(item, isSelected);
      })
    }
  })
}

let endIndex = -1;
// table 选择增加 shift
const isShiftPressed = ref(false); // 标记 Shift 键是否被按下
const handleKeyDown = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    // console.log("进来了-----------------", event.key, event.keyCode);
    isShiftPressed.value = true;
  }
};

const handleKeyUp = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    isShiftPressed.value = false;
  }
};

// 监听 tableData 变化，恢复选中状态
watch(() => tableData.value, (newValue) => {
  if (newValue) {
    console.log('tableData changed, restoring selection')
    resetSelection()
  }
}, {immediate: true})


// 弹窗进行编辑备注
const visitableRemark = ref(false)
const currentItem = ref({remark: ""})
const emailListCheckoutTarget = ref({remark: ''})
const handleClickRemark = (row) => {
  const {id} = row
  console.log(id, row, 'id')
  currentItem.value = row
  visitableRemark.value = true
}
const closeRemark = () => {
  visitableRemark.value = false
}

const sendAllStaticData = ref({totalCount: 0, successCount: 0, openCount: 0, replyCount: 0, failCount: 0})
const isShowDataLoading = ref(false)
// 顶部展示的内容
const showTopDataList = computed(() => ([
  {key: 1, name: i18n.global.t('common.edm.number'), data: sendAllStaticData.value?.totalCount, imgSrc: img1},
  {key: 2, name: i18n.global.t('common.edm.send'), data: sendAllStaticData.value?.successCount, imgSrc: img2},
  {key: 3, name: i18n.global.t('common.edm.open'), data: sendAllStaticData.value?.openCount, imgSrc: img3},
  {key: 4, name: i18n.global.t('common.edm.reply'), data: sendAllStaticData.value?.replyCount, imgSrc: img4},
  {key: 5, name: i18n.global.t('common.edm.fail'), data: sendAllStaticData.value?.failCount, imgSrc: img5}
]))

const options = [
  {
    value: 1,
    label: i18n.global.t('common.step.txt.select.1'),
  },
  {
    value: 2,
    label: i18n.global.t('common.step.txt.select.2'),
  },
  {
    value: 3,
    label: i18n.global.t('common.step.txt.select.3'),
  },
  {
    value: 4,
    label: i18n.global.t('common.step.txt.select.4'),
  },
  {
    value: 5,
    label: i18n.global.t('common.step.txt.select.5'),
  },
  {
    value: 6,
    label: i18n.global.t('common.step.txt.select.6'),
  },
  {
    value: 7,
    label: i18n.global.t('common.step.txt.select.7'),
  },
  {
    value: 8,
    label: i18n.global.t('common.step.txt.select.8'),
  },
]

const getGroupStatic = async () => {
  try {
    const payload = {
      ...searchForm.value,
      teamId: teamId.value,
      // createBy: tableDataSelect.value[0].userId,
    }
    if (!payload.createBy) {
      payload.createBy = tableDataSelect.value[0].userId;
    }
    if (payload.createBy === "all") {
      payload.createBy = "";
    }

    isShowDataLoading.value = true
    const res = await getGroupStaticData(payload)
    isShowDataLoading.value = false
    console.log(res.result, 'resddddadsfa')
    sendAllStaticData.value = res?.result || {totalCount: 0, successCount: 0, openCount: 0, replyCount: 0, failCount: 0}
  } catch (e) {
    isShowDataLoading.value = false
    console.log(e)
  }
}

function renderHeader({column}) {
  // 获取操作按钮组的元素
  const opts = document.getElementsByClassName('optionDiv')
  let widthArr = []
  // 取操作组的最大宽度
  Array.prototype.forEach.call(opts, function (item) {
    if (item.innerText) {
      widthArr.push(item.offsetWidth)
    }
  })
  // 重新设置列标题及宽度属性
  if (widthArr.length > 0) {
    column.width = Math.max(...widthArr) + 30
    return column.label
  } else {
    column.width = 0
    return column.label
  }
}
</script>


<style lang="less" scoped>
@import "../../less/page.less";

.box {
  width: 100%;
  height: 100%;
  background: white;

  .top_box {
    height: 120px;
    width: 100%;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;

    .top_left {
      width: 50%;
      min-width: 580px;
      height: 100%;
      flex: 0 0 auto; /* 不压缩，不增长 */

      .content_box {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;

        .content_bottom {
          display: flex;
          justify-content: flex-start;

          & > div {
            margin-left: 30px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
          }

          & > div:nth-of-type(1) {
            margin-left: 0;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
          }
        }
      }
    }

    .top_right {
      width: 50%;
      flex: 1 1 auto; /* 不压缩，不增长 */
      display: flex;
      justify-content: space-around;
      align-items: center;

      & > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .content {
    width: 100%;
    height: 100%;
    background: #f6f6f6;
    padding: 8px;

    & > div {
      display: flex;
      padding: 0px 10px;
    }

    & > div:nth-of-type(2) {
      width: 100%;
      min-height: 40px;
      max-height: max-content;
      padding: 6px;
      background: white;
    }

    & > div:nth-of-type(3) {
      width: 100%;
      margin-top: 8px;
      padding: 2px 6px 6px 6px;
      height: max-content !important;
      background: white;
    }
  }
}

.font {
  font-size: 16px;
  font-weight: 500;
}

.font_small {
  font-size: 12px;
  min-width: 48px;
}

.font_big {
  font-size: 22px;
  font-weight: 500;
}

.font_small_color {
  color: #b9b9b9;
}

span {
  line-height: 16px;
}

:deep(.el-button+.el-button) {
  margin-left: 0px;
}

.demo-ruleForm {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & > div {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
}

:deep(.el-form-item) {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.table_top {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 4px;
}

.table_font {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
}

:deep(.el-table__header) {
  min-width: 100%;
}

:deep(.el-table__body) {
  min-width: 100%;
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-empty__description) {
  margin-top: -20px;
}

:deep(.el-form-item__label) {
  font-weight: normal !important;
  font-size: 14px !important;
}

:deep(.el-range-input) {
  width: 40% !important;
}

:deep(.el-date-editor .el-range-separator) {
  flex: none !important;
}

:deep(.el-range-separator) {
  color: #a9abb1;
}

.btn_reset {
  cursor: text !important;
  pointer-events: none
}

:deep(.el-form-item__label-wrap) {
  margin-left: 10px !important;
}

.h2_titles {
  font-size: 16px;
  margin-top: 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}

:deep(.el-form-item__label) {
  font-weight: 700;
}

:deep(.el-select) {
  width: 200px !important;
}

:deep(.el-range-editor.el-input__wrapper) {
  padding: 0px 5px 0px 5px !important;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}

:deep(.el-table__header-wrapper th .cell) {
  white-space: nowrap !important;
  word-break: keep-all !important;
}

:deep(.el-button) {
  font-size: 13px !important;
}

:deep(.el-input__inner) {
  font-size: 13px !important;
}

:deep(.el-select__input) {
  font-size: 13px !important;
}

:deep(.el-form-item__label) {
  font-size: 13px !important;
}

.popover-content {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

.pages :deep(.el-pagination .el-select) {
  width: 100px !important;
}

:deep(.el-pagination) {
  position: relative !important;
  background: white !important;
  z-index: 9;
}

#top_data_show {
  background: white;
  padding: 24px 40px !important;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;

  .data_item {
    display: flex;
    height: max-content;
  }
}
</style>
